import { DecimalPipe } from "@angular/common";
import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateDirective } from "@ngx-translate/core";
import { FeatureService } from "~app/common/services/feature.service";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { ArbetsorderService } from "../../services/arbetsorder.service";

@Component({
    selector: "rask-planera-ao-popup",
    templateUrl: "./planera-ao-popup.component.html",
    styleUrls: ["./planera-ao-popup.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterLink,
        TranslateDirective,
        DecimalPipe
    ]
})
export class PlaneraAoPopupComponent {
    arbetsorder: IArbetsorderDetail;

    private readonly arbetsorderService = inject(ArbetsorderService);
    private readonly featureService = inject(FeatureService);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("data")
    set data(value: any) {
        this.arbetsorder = value;
    }

    getArbetsorderPeriod(arbetsorder) {
        return this.arbetsorderService.getArbetsorderOperationPeriod(arbetsorder);
    }
}
